var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "icon-heart-a",
    points: "0 0 23 0 23 20.346 0 20.346"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-heart-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-heart-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M6.12023394,1.70949213 C7.21985296,1.70949213 8.32638058,2.15614829 9.18757611,3.04605101 L10.8640634,4.78266832 C11.0298697,4.95542082 11.2613079,5.05316237 11.5042604,5.05316237 C11.7460614,5.05316237 11.9774995,4.95542082 12.1444574,4.78266832 L13.8117332,3.05514325 C15.5331263,1.27647434 18.2158896,1.27647434 19.9372828,3.05514325 C21.6586759,4.83381215 21.6586759,7.71385406 19.9372828,9.49244721 C17.1254821,12.3974927 14.3113785,15.2978407 11.4995779,18.202962 L3.06187296,9.48343077 C1.34047983,7.70248876 1.34047983,4.82471992 3.06187296,3.04612678 C3.92314523,2.15622405 5.02046139,1.70949213 6.12008041,1.70949213 L6.12023394,1.70949213 Z M6.12023394,0 C4.54507287,0 2.96975827,0.609331431 1.78155563,1.83678346 C-0.595003172,4.2916875 -0.592700305,8.22635316 1.78155563,10.6834545 L10.8547751,20.0756598 C11.0205815,20.2484123 11.2520964,20.3461538 11.4949721,20.3461538 C11.7367731,20.3461538 11.968288,20.2484123 12.1351691,20.0756598 C15.1624414,16.9490667 18.1906349,13.8190641 21.2175234,10.692471 C23.5941589,8.23756693 23.5941589,4.30055244 21.2175234,1.84579993 C18.8409645,-0.608952588 14.9169558,-0.609104125 12.5402435,1.84579993 L11.4993476,2.90959168 L10.4584516,1.83670769 C9.27017229,0.609255662 7.69501119,0 6.11977336,0 L6.12023394,0 Z",
    mask: "url(#icon-heart-b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon-heart.acc32cb177101586c8664a3b0f7cb02c.svg";
export { ForwardRef as ReactComponent };